const ArchiveMusicVideos2023Static = () => {
    return (
      <>
        <div class="music-video">

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/I0-9h_qYDhg" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lugosi</strong><br/>
            Lugosi @ CRACKFEST VI (Full Set)
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/Oa17vu2-w2E" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Hellscape Radio Vol. 6</strong><br/>
            Hellscape Digital @ CRACKFEST VI (Full Set)
          </p>

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/cSAXCagiLRg" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lugosi</strong><br/>
            paranoid
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/ioJ2ZLxPN7U" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Kawaii Ry</strong><br/>
            I'm Serious (LEGO Island AMV) [480p]
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/EgCdIxRRYdI" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lugosi</strong><br/>
            PHOTO (prod. chris6lair & Rio Leyva)
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/21VuClIGW4o" title="Hellscape Radio Vol. 5" allowfullscreen></iframe>
            </div>
            <p class="video-title-text">
            <strong>Hellscape Radio Vol. 5</strong><br/>
            Kawaii Ry @ CRACKFEST V (Full Set)
            </p>

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/viEzTBEkDMw" title="SWAG SUPPLIER" allowfullscreen></iframe>
            </div>
            <p class="video-title-text">
            <strong>QADRI</strong><br/>
            IDONTWANNASEEYOU (feat. rileylol)
            </p>
            
        </div>
      </>
    );
  };
  export default ArchiveMusicVideos2023Static;